
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","width":"64","height":"64","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M78.75 16.18V1.56a64.1 64.1 0 0147.7 47.7H111.8a49.98 49.98 0 00-33.07-33.08zM16.43 49.25H1.8a64.1 64.1 0 0147.7-47.7V16.2a49.98 49.98 0 00-33.07 33.07zm33.07 62.32v14.62A64.1 64.1 0 011.8 78.5h14.63a49.98 49.98 0 0033.07 33.07zm62.32-33.07h14.62a64.1 64.1 0 01-47.7 47.7v-14.63a49.98 49.98 0 0033.08-33.07z","fill":"#1b3186"}}),_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 64 64","to":"-90 64 64","dur":"400ms","repeatCount":"indefinite"}})])])
          )
        }
      }
    